// Constants
import { OfferIdEnum } from '../../constants'

// Utilities
import isEmpty from '../../utility/isEmpty'

export default {
  recognizedOffers (state) {
    const offerIds = Object.values(OfferIdEnum)
    return Array.isArray(state.offers) ? state.offers.filter(offer => offerIds.indexOf(offer.offerId) > -1) : []
  },

  getStyles: (state) => (textSection) => {
    let styles = ''

    if (!isEmpty(textSection)) {
      if (!isEmpty(textSection.weight)) {
        if (textSection.weight === 'bold') {
          styles = 'text-600'
        } else if (textSection.weight === 'light') {
          styles = 'text-300'
        }
      }

      if (!isEmpty(textSection.size)) {
        styles += ` text-${textSection.size}`
      }

      if (!isEmpty(textSection.style)) {
        if (textSection.style === 'italic') {
          styles += ' text-italic'
        } else if (textSection.style === 'underline') {
          styles += ' text-underline'
        }
      }

      if (!isEmpty(textSection.lineBreak)) {
        styles += ' d-block text-white'
      }

      if (!isEmpty(textSection.newLine) && textSection.newLine === true) {
        styles += ' d-block'
      }
    }

    return styles
  }
}
